<template>
  <div>
    <!-- Exibe um overlay de carregamento enquanto os dados são carregados -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Container de informações da página -->
    <div class="top_info_container">
      <!-- Botão para registrar novo bolseiro, visível apenas se a função do usuário permitir -->
      <v-btn 
        v-if="funcaoPorROle.verificarFuncao(4)" 
        @click="$router.push('/esc-pagamento')" 
        style="background-color:#006699; color:white;" 
        outlined
      >
        <v-icon md color="white">add</v-icon> Registrar Bolseiro
      </v-btn>
      <v-toolbar-title class="titulo_pagina">Lista dos bolseiros activos</v-toolbar-title>
    </div>

    <!-- Tabela de dados dos bolseiros -->
    <v-data-table :headers="headers" :items="bolseiros" :items-per-page="8">
      <!-- Coluna personalizada para o índice -->
      <template v-slot:item.indice="{ item }">
        <span>{{ bolseiros.indexOf(item) + 1 }}</span>
      </template>

      <!-- Coluna personalizada para o campo de desconto -->
      <template v-slot:item.desconto="{ item }">
        <span>
          {{ item.isPercentagem === 1 ? item.desconto + '%' : utilitarios.IntegerToMoneyValueFatura(item.desconto) }}
        </span>
      </template>

      <!-- Coluna de ações, com menu de opções -->
      <template v-slot:item.action="{ item }">
        <v-menu bottom origin="center center" transition="scale-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn fab dark small color="#006699" v-bind="attrs" v-on="on">
              <v-icon dark>menu</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item v-if="funcaoPorROle.verificarFuncao(22)" @click="revogarBolsa(item)">
              <v-icon color="red">delete</v-icon> Revogar Bolsa
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
  </div>
</template>


<script>
import Swal from 'sweetalert2';
import axios from '../../plugins/axios';
import funcaoPorROle from '../../utilitarios/funcao.untilitario';
import utilitarios from "../../plugins/utilitarios";

export default {
  data: () => ({
    funcaoPorROle,
    utilitarios,
    overlay: false,
    bolseiros: [],
    headers: [
      { text: '#', value: 'indice' },
      { text: 'Nome', align: 'start', sortable: false, value: 'nome' },
      { text: 'Bilhete', value: 'bi' },
      { text: 'Matrícula', value: 'matricula' },
      { text: 'Curso', value: 'curso' },
      { text: 'Organização', value: 'ongBolsa' },
      { text: 'Desconto', value: 'desconto' },
      { text: 'Ação', value: 'action' }
    ],
  }),

  created() {
    this.listarBolseiros(); // Carrega a lista de bolseiros ao criar o componente
  },

  methods: {
    /**
     * Lista todos os bolseiros ativos no sistema.
     * Em caso de erro, exibe uma mensagem de notificação.
     */
    async listarBolseiros() {
      this.overlay = true;
      try {
        const response = await axios.get('/listarBolseirosActivos');
        this.bolseiros = response.data;
      } catch (error) {
        Swal.fire('Erro', 'Ocorreu um erro durante o carregamento da página', 'error'); // Notificação de erro
      } finally {
        this.overlay = false;
      }
    },

    /**
     * Revoga a bolsa de um estudante selecionado.
     * Em caso de sucesso, atualiza a lista de bolseiros e exibe uma mensagem de sucesso.
     * Caso contrário, exibe uma notificação de erro.
     * @param {Object} estudante - Objeto do estudante selecionado para revogação
     */
    async revogarBolsa(estudante) {
      this.overlay = true;
      try {
        const params = { matricula: estudante.matricula };
        const operacao = await axios.post('/revogarBolsaEstudante', params);

        if (operacao.status === 200 && operacao.data.affectedRows >= 1) {
          Swal.fire('Sucesso', 'Bolseiro revogado com sucesso!', 'success');
          this.listarBolseiros();
        }
      } catch (error) {
        Swal.fire('Erro', 'Ocorreu um erro durante a revogação da bolsa!', 'error');
      } finally {
        this.overlay = false;
      }
    }
  }
}
</script>

<style scoped>
/* Estilos específicos podem ser adicionados aqui, caso necessário */
</style>
